import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import "./style.scss";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 300,
    },
  },
};

export default function MultiSelect({
  options = [],
  label,
  value,
  onChange,
  name,
}) {
  //   const handleChange = (event) => {
  //     const {
  //       target: { value },
  //     } = event;
  //     onChange;
  //   };

  return (
    <div className="w-full">
      <InputLabel className="dark:text-white mb-2">{label}</InputLabel>
      <FormControl sx={{ m: 1 }} className="w-full !m-0 p-[6px]">
        <InputLabel id="multiselect-label">{label}</InputLabel>
        <Select
          labelId="multiselect-label"
          multiple
          value={value || []}
          name={name}
          onChange={onChange}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected) => selected.join(", ")}
          MenuProps={MenuProps}
          className="custom-multiselect"
        >
          {options.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={value && value.includes(name)} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
